import { getApiSLice } from "utils/getApiBaseQuery";

export const dashboardsApiSlice = getApiSLice("dev").injectEndpoints({
  endpoints: (builder) => ({
    getManagerDashboard: builder.query({
      query: ({ period }) => ({
        url: `/controlcenter/GetManagerDashbord?period=${period}`,
        method: "GET",
      }),
    }),
    getOnlineDashboard: builder.query({
      query: () => ({
        url: "/controlcenter/GetOnlineDashboard",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetManagerDashboardQuery, useGetOnlineDashboardQuery } =
  dashboardsApiSlice;
